function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

require('./ImageUploadPlaceholder.js');

require('./style.js');

var imageIdManger = require('./imageIdManger');

var constant = require('./constant');

var ImageUpload = /*#__PURE__*/function () {
  function ImageUpload(quill, options) {
    _classCallCheck(this, ImageUpload);

    this.quill = quill;
    this.options = options;
    this.range = null;
    if (typeof this.options.upload !== "function") console.warn('[Missing config] upload function that returns a promise is required');
    var toolbar = this.quill.getModule("toolbar");
    toolbar.addHandler("image", this.selectLocalImage.bind(this));
  }

  _createClass(ImageUpload, [{
    key: "selectLocalImage",
    value: function selectLocalImage() {
      this.range = this.quill.getSelection();
      this.fileHolder = document.createElement("input");
      this.fileHolder.setAttribute("type", "file");
      this.fileHolder.setAttribute('accept', 'image/*');
      this.fileHolder.onchange = this.fileChanged.bind(this);
      this.fileHolder.click();
    }
  }, {
    key: "fileChanged",
    value: function fileChanged() {
      var _this = this;

      var file = this.fileHolder.files[0];
      var imageId = imageIdManger.generate();
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        var base64ImageSrc = fileReader.result;

        _this.insertBase64Image(base64ImageSrc, imageId);
      }, false);

      if (file) {
        fileReader.readAsDataURL(file);
      }

      this.options.upload(file).then(function (imageUrl) {
        _this.insertToEditor(imageUrl, imageId);
      }, function (error) {
        console.warn(error.message);
      });
    }
  }, {
    key: "insertBase64Image",
    value: function insertBase64Image(url, imageId) {
      var range = this.range;
      this.quill.insertEmbed(range.index, "imageUpload", "".concat(imageId).concat(constant.ID_SPLIT_FLAG).concat(url));
    }
  }, {
    key: "insertToEditor",
    value: function insertToEditor(url, imageId) {
      var imageElement = document.getElementById(imageId);

      if (imageElement) {
        imageElement.setAttribute('src', url);
        imageElement.removeAttribute('id');
        imageElement.classList.remove(constant.IMAGE_UPLOAD_PLACEHOLDER_CLASS_NAME);
      }
    }
  }]);

  return ImageUpload;
}();

module.exports = ImageUpload;